import React from 'react'

import Modal from 'components/Modal'
import { Flex, SUI } from 'shared/ui'

import SearchingState from './SearchingState'
import CreatingNewState from './CreatingNewState'

// eslint-disable-next-line react/no-multi-comp
const ChangeUserModal = ({
  bottom = 20,
  offset,
  onClose,
  open,
  isSearching,
  isCreatingNew,
  openSearching,
  ...rest
}) => {
  if (!open) return null

  return (
    <Modal
      styleContainer={{ maxHeight: `calc(100% - ${bottom}px - ${top}px)` }}
      offset={offset}
      onBackgroundClick={onClose}
    >
      <SUI>
        <Flex
          flexDirection="column"
          css={`
            width: 100vw;
            max-width: 260px;
            max-height: 419px;
          `}
        >
          {isSearching && <SearchingState {...rest} />}
          {isCreatingNew && (
            <CreatingNewState
              {...rest}
              initialValues={{ name: '', email: '' }}
              closeForm={openSearching}
            />
          )}
        </Flex>
      </SUI>
    </Modal>
  )
}

// eslint-disable-next-line react/no-multi-comp
class MountedModal extends React.Component {
  componentDidUpdate(prevProps) {
    const { onModalOpen, open, reset } = this.props
    if (!prevProps.open && open && onModalOpen) return onModalOpen()
    if (prevProps.open && !open && reset) return reset()
    return null
  }

  runAndClose = fn => (...args) => {
    fn(...args)
    this.props.onClose()
  }

  closeAndRun = fn => (...args) => {
    this.props.onClose()
    return fn(...args)
  }

  render() {
    const { onSave, onSelect, onClose } = this.props

    return (
      <ChangeUserModal
        {...this.props}
        onSave={this.runAndClose(onSave)}
        onSelect={this.runAndClose(onSelect)}
        onCancel={onClose}
      />
    )
  }
}

export default MountedModal
